// avstemming-loans-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avdl.toast.noBackend': 'Låneregisteret er ikke koblet til backend.',
  'avdl.toast.registered': 'Lånet er registrert',
  'avdl.toast.saved': 'Lånet er lagret',
  'avdl.toast.removed': 'Lånet er fjernet fra registeret',
  'avdl.toast.noAccount': 'Låneområdet har ingen avstemmingskonto i denne perioden.',
  'avdl.nav.accounting': 'Regnskapsdata',
  'avdl.nav.register': 'Låneoversikt',
  'avdl.nav.loansCount': '{count} lån',
  'avdl.nav.documents': 'Eksternt grunnlag',
  'avdl.nav.missingCount': '{count} mangler',
  'avdl.nav.complete': 'Komplett',
  'avdl.nav.difference': 'Differanseberegning',
  'avdl.nav.verified': 'Verifisert',
  'avdl.nav.items': 'Avstemmingsposter',
  'avdl.nav.openCount': '{count} åpne',
  'avdl.nav.classification': 'Klassifisering',
  'avdl.nav.noPlan': 'Uten plan',
  'avdl.nav.controls': 'Kontroll og konklusjon',
  'avdl.area.loans': 'Lån og gjeld',
  'avdl.header.hintMissing': '{count} lån mangler gyldig dokumentasjon for perioden.',
  'avdl.header.hintAll': 'Alle registrerte lån har grunnlag for perioden.',
  'avdl.header.title': 'Lån og gjeld — register, långiverens saldo og klassifisering',
  'avdl.header.responsible': 'Ansvarlig {name}',
  'avdl.header.unverified': '{amount} ikke verifisert',
  'avdl.header.allVerified': 'All saldo er verifisert',
  'avdl.header.summary': '{count} registrerte lån med samlet bokført saldo {amount}.',
  'avdl.header.summaryUnverified': '{amount} av dette kan ikke verifiseres fordi gyldig dokumentasjon fra långiver mangler for perioden.',
  'avdl.header.summaryVerified': 'All saldo er verifisert mot dokumentasjon fra långiver.',
  'avdl.header.zeroDiffNote': 'En differanse på null er ikke det samme som en avstemt gjeld. Bokført saldo ingen långiver har bekreftet står som ikke verifisert, og telles ikke som avstemt uansett hva de øvrige lånene viser.',
  'avdl.header.noAccountAlert': 'Området har ingen avstemmingskonto i denne perioden. Dokumentasjon og avstemmingsposter kan derfor ikke lagres før en gjeldskonto er med i perioden.',
  'avdl.status.unverified': 'Ikke verifisert',
  'avdl.status.incomparable': 'Kan ikke sammenliknes',
  'avdl.status.hasDifference': 'Har differanse',
  'avdl.status.reconciled': 'Avstemt',
  'avdl.acc.title': 'Regnskapsdata',
  'avdl.acc.source': 'Hentet fra saldobalansen',
  'avdl.acc.sourceAt': 'Hentet fra saldobalansen per {date}',
  'avdl.acc.booked': 'Bokført låne- og gjeldssaldo',
  'avdl.acc.opening': 'Saldo forrige periode',
  'avdl.acc.change': 'Endring denne perioden',
  'avdl.acc.loanCount': 'Antall registrerte lån',
  'avdl.acc.unverified': 'Ikke-verifisert bokført saldo',
  'avdl.acc.classificationGap': 'Mulig klassifiseringsavvik',
  'avdl.acc.hideAccounts': 'Skjul kontooversikt',
  'avdl.acc.showAccounts': 'Vis kontooversikt',
  'avdl.acc.colAccount': 'Konto',
  'avdl.acc.colClass': 'Klassifisering',
  'avdl.acc.colOpening': 'Inngående',
  'avdl.acc.colMovement': 'Bevegelse',
  'avdl.acc.colBooked': 'Bokført saldo',
  'avdl.acc.longTerm': 'Langsiktig gjeld',
  'avdl.acc.shortTerm': 'Kortsiktig gjeld',
  'avdl.acc.unreadable': 'Ikke lest av kontonummeret',
  'avdl.acc.noAccounts': 'Ingen låne- eller gjeldskontoer i denne perioden.',
  'avdl.flag.unverified': 'Ikke verifisert mot långiver',
  'avdl.flag.difference': 'Differanse mot långiver',
  'avdl.flag.noPlan': 'Mangler nedbetalingsplan',
  'avdl.flag.foreign': 'Lån i annen valuta enn NOK',
  'avdl.flag.sharesAccount': 'Deler hovedbokskonto',
  'avdl.tile.unverifiedHint': 'Lån uten en saldobekreftelse eller låneoppgave som dekker periodeslutt.',
  'avdl.tile.withDifference': 'Lån med differanse',
  'avdl.tile.withDifferenceHint': 'Verifiserte lån der bokført saldo og långiverens saldo ikke er den samme.',
  'avdl.tile.noPlanHint': 'Uten en nedbetalingsplan kan ikke den kortsiktige delen fastsettes.',
  'avdl.tile.foreign': 'Lån i annen valuta',
  'avdl.tile.foreignHint': 'Kursen på balansedagen må kontrolleres.',
  'avdl.tile.sharesAccountHint': 'Flere lån på samme konto. Kontoens saldo er da ikke ett låns bokførte saldo, og differansen kan ikke regnes per lån.',
  'avdl.tile.unregistered': 'Gjeldskontoer uten lån',
  'avdl.tile.unregisteredHint': 'Saldo på en gjeldskonto uten et registrert lån bak. Listes under låneoversikten.',
  'avdl.card.title': 'Kontrollkort',
  'avdl.card.loans': 'Registrerte lån: {count}',
  'avdl.card.verified': 'Verifisert mot långiver: {count}',
  'avdl.card.unexplained': 'Uforklart differanse: {amount}',
  'avdl.card.activeFilter': 'Aktivt filter: {label}',
  'avdl.card.removeFilter': 'Fjern filter',
  'avdl.reg.resetFilter': 'Nullstill filter',
  'avdl.reg.newLoan': 'Registrer lån',
  'avdl.reg.note': 'Lånene ligger i foretakets oppsett, som bankkontoene. Et lån som registreres her blir stående i låneregisteret og brukes også av balanseoppstillingen.',
  'avdl.reg.colLoan': 'Långiver / lån',
  'avdl.reg.colAccount': 'Konto',
  'avdl.reg.colBooked': 'Bokført saldo',
  'avdl.reg.colDocumented': 'Dokumentert saldo',
  'avdl.reg.colDifference': 'Differanse',
  'avdl.reg.colDocumentation': 'Dokumentasjon',
  'avdl.reg.colStatus': 'Status',
  'avdl.reg.sharedWithOther': 'Deles med et annet lån',
  'avdl.reg.shared': 'Deles',
  'avdl.reg.open': 'Åpne',
  'avdl.reg.noMatch': 'Ingen lån passer med filteret.',
  'avdl.reg.noLoans': 'Ingen lån er registrert. Er det bokført gjeld på kontoene over, må lånene registreres før den kortsiktige delen kan fastsettes.',
  'avdl.reg.unregisteredOne': 'Én gjeldskonto har saldo uten et registrert lån: {accounts}. Uten en nedbetalingsplan kan ikke den kortsiktige delen fastsettes.',
  'avdl.reg.unregisteredMany': '{count} gjeldskontoer har saldo uten et registrert lån: {accounts}. Uten en nedbetalingsplan kan ikke den kortsiktige delen fastsettes.',
  'avdl.cls.title': 'Klassifisering av gjeld',
  'avdl.cls.bookedTotal': 'Samlet bokført gjeld',
  'avdl.cls.verifiedDebt': 'Dokumentert og verifisert gjeld',
  'avdl.cls.unverifiedDebt': 'Ikke-verifisert gjeld',
  'avdl.cls.bookedLong': 'Bokført som langsiktig',
  'avdl.cls.bookedShort': 'Bokført som kortsiktig',
  'avdl.cls.documentedNext12': 'Dokumenterte avdrag neste 12 måneder',
  'avdl.cls.plannedNext12': 'Avdrag neste 12 måneder etter planene',
  'avdl.cls.noPlan': 'Ingen plan',
  'avdl.cls.countryNote': 'Skillet mellom kortsiktig og langsiktig gjeld leses av den norske kontoplanen. Regnskapslandet er {country}, og klassifiseringen må derfor vurderes manuelt.',
  'avdl.cls.unclassified': '{amount} av den bokførte gjelden ligger på kontoer utenfor både langsiktig og kortsiktig gjeld. Kontoen må flyttes, eller området er satt opp med en konto som ikke er gjeld.',
  'avdl.cls.missingPlanOne': 'Ett lån mangler nedbetalingsplan. Uten planen kan avdragene de neste tolv månedene ikke regnes ut, og feltet står tomt i stedet for å bli gjettet.',
  'avdl.cls.missingPlanMany': '{count} lån mangler nedbetalingsplan. Uten planen kan avdragene de neste tolv månedene ikke regnes ut, og feltet står tomt i stedet for å bli gjettet.',
  'avdl.cls.provisional': 'Foreløpig – må bekreftes mot oppdatert nedbetalingsplan',
  'avdl.cls.gapNote': 'Avdrag på {amount} forfaller de neste 12 månedene ut fra lånenes egne planer, men er ikke bokført som kortsiktig gjeld. Omklassifiseringen er byråets vurdering — avdragsfrihet, brudd på lånevilkår og refinansiering etter balansedagen endrer svaret uten at planen viser det. Er vurderingen at gjelden skal flyttes, registreres den som en avstemmingspost med klassifiseringen «Feil kortsiktig/langsiktig klassifisering».',
  'avdl.derived.registered': 'Alle gjeldskontoer med saldo har et registrert lån',
  'avdl.derived.registeredOpen': '{count} konto uten lån',
  'avdl.derived.registeredNone': 'Ingen gjeldskonto står uten lån',
  'avdl.derived.documented': 'Alle lån har gyldig dokumentasjon for perioden',
  'avdl.derived.documentedOpen': '{count} lån mangler gyldig grunnlag',
  'avdl.derived.documentedNone': 'Alle lån er dokumentert',
  'avdl.derived.difference': 'Differansen mot långiverne er forklart',
  'avdl.derived.differenceOpen': '{amount} er uforklart',
  'avdl.derived.differenceNone': 'Ingen uforklart differanse',
  'avdl.derived.interest': 'Påløpte renter og gebyrer er behandlet',
  'avdl.derived.interestOpen': '{amount} er opplyst uten å være bokført',
  'avdl.derived.interestNone': 'Ingenting står opplyst som ubokført',
  'avdl.derived.plan': 'Alle lån har en nedbetalingsplan å klassifisere etter',
  'avdl.derived.planOpen': '{count} lån mangler plan',
  'avdl.derived.planNone': 'Alle lån har plan',
  'avdl.derived.classification': 'Kortsiktig andel er i tråd med planene',
  'avdl.derived.classificationOpen': '{amount} forfaller uten å stå som kortsiktig',
  'avdl.derived.classificationNone': 'Ingen forskjell mot planene',
  'avdl.blocker.unregisteredOne': 'Én gjeldskonto med saldo har ikke et registrert lån',
  'avdl.blocker.unregisteredMany': '{count} gjeldskontoer med saldo har ikke et registrert lån',
  'avdl.blocker.documentation': 'Gyldig dokumentasjon mangler for {count} lån',
  'avdl.blocker.unverified': 'Bokført saldo på {amount} er ikke verifisert',
  'avdl.blocker.difference': '{amount} av differansen mot långiverne er uforklart',
  'avdl.blocker.accrued': 'Påløpte renter og gebyrer på {amount} må behandles',
  'avdl.blocker.classification': 'Mulig klassifiseringsavvik på {amount} må bekreftes',
  'avdl.blocker.pointOne': 'Ett kontrollpunkt gjenstår',
  'avdl.blocker.pointMany': '{count} kontrollpunkter gjenstår',
  'avdl.checks.title': 'Kontroller',
  'avdl.checks.colCheck': 'Kontroll',
  'avdl.checks.colFindings': 'Funn',
  'avdl.checks.colStatus': 'Status',
  'avdl.checks.needsReview': 'Krever gjennomgang',
  'avdl.checks.none': 'Ingen funn',
  'avdl.check.title': 'Faglig sjekkliste',
  'avdl.check.titleReadOnly': 'Faglig sjekkliste (utførerens, skrivebeskyttet)',
  'avdl.check.noPoints': 'Ingen kontrollpunkter er definert for lån og gjeld i denne perioden.',
  'avdl.check.scope': 'Punktene gjelder hele området. En avkryssing lagres på alle gjeldskontoene i perioden.',
  'avdl.check.groupDerived': 'Følger av lånene',
  'avdl.check.groupAssessments': 'Faglige vurderinger',
  'avdl.check.groupReady': 'Klarstilling',
  'avdl.check.count': '{done} av {total}',
  'avdl.check.followsNumbers': 'Følger av tallene',
  'avdl.check.performedBy': 'Utføres av {name}',
  'avdl.check.completed': '{done} av {total} kontrollpunkter fullført',
  'avdl.concl.title': 'Konklusjon og godkjenning',
  'avdl.concl.loansChecked': 'Lån kontrollert',
  'avdl.concl.loansWithoutDocs': 'Lån uten gyldig dokumentasjon',
  'avdl.concl.unexplainedDifference': 'Uforklart avstemmingsdifferanse',
  'avdl.concl.accrued': 'Påløpte renter og gebyrer',
  'avdl.concl.conclusion': 'Konklusjon',
  'avdl.concl.placeholder': 'Hva viser gjennomgangen av lån og gjeld for denne perioden?',
  'avdl.concl.savedAs': 'Lagres som begrunnelsen på kontrollpunktet «{label}».',
  'avdl.concl.remainingRisk': 'Gjenstående risiko',
  'avdl.concl.noRisk': 'Ingenting står igjen som hindrer at området sendes til kontroll.',
  'avdl.concl.followUp': 'Oppfølging neste periode',
  'avdl.concl.noFollowUp': 'Ingen poster er merket for oppfølging, og alle lån har grunnlag for perioden.',
  'avdl.concl.missingEvidence': 'Mangler grunnlag',
  'avdl.concl.getStatement': 'Innhent oppdatert låneoppgave. {status}.',
  'avdl.common.openLoan': 'Åpne lånet',
  'avdl.concl.reconItem': 'Avstemmingspost',
  'avdl.common.followed': 'Følges opp',
  'avdl.concl.measure': 'Tiltak: {text}',
  'avdl.concl.noMeasure': 'Ingen tiltak notert',
  'avdl.concl.deadline': 'Frist {date}',
  'avdl.concl.send': 'Send området til kontroll',
  'avdl.concl.oneLeft': 'Én ting står igjen før området kan sendes.',
  'avdl.concl.manyLeft': '{count} ting står igjen før området kan sendes.',
  'avdl.docs.title': 'Eksternt grunnlag',
  'avdl.docs.unverifiedNote': '{amount} av bokført gjeld kan ikke verifiseres fordi gyldig dokumentasjon fra långiver mangler for perioden:',
  'avdl.docs.colDocument': 'Dokument',
  'avdl.docs.colType': 'Type',
  'avdl.docs.colBalanceDate': 'Saldodato',
  'avdl.docs.colLender': 'Långiver',
  'avdl.docs.notLinked': 'Ikke koblet til lån',
  'avdl.docs.view': 'Vis',
  'avdl.docs.uploaded': 'Lastet opp:',
  'avdl.docs.source': 'Kilde:',
  'avdl.docs.sourceClient': 'Klienten',
  'avdl.docs.sourceFirm': 'Byrået',
  'avdl.docs.by': 'Av:',
  'avdl.docs.accounts': 'Kontoer:',
  'avdl.docs.loanStatement': 'Låneoppgave',
  'avdl.docs.requestDocs': 'Be klienten om dokumentasjon',
  'avdl.docs.empty': 'Ingen dokumentasjon er lagt ved på låneområdet i denne perioden.',
  'avdl.docs.footer': 'Dokumenter lastes opp i dokumentfanen i høyrepanelet, og kobles til lånet i låneskuffen — der saldoen og saldodatoen som leses av dokumentet også registreres.',
  'avdl.diff.critical': 'Kritisk avvik – må avklares før godkjenning',
  'avdl.diff.unexplained': 'Uforklart differanse',
  'avdl.diff.difference': 'Differanse',
  'avdl.diff.partA': 'A. Avstemming av dokumenterte lån',
  'avdl.diff.bookedCovered': 'Bokført saldo omfattet av dokumentasjon',
  'avdl.diff.documentedFromLenders': 'Dokumentert saldo fra långivere',
  'avdl.diff.preliminary': 'Foreløpig differanse',
  'avdl.diff.explained': 'Forklarte differanser',
  'avdl.diff.unexplainedLabel': 'Uforklart differanse',
  'avdl.diff.noneVerified': 'Ingen lån har gyldig dokumentasjon for perioden ennå. Da er det ingenting å avstemme her — hele saldoen står under B.',
  'avdl.diff.partB': 'B. Saldo som ikke er verifisert',
  'avdl.diff.criticalDocs': 'Kritisk – dokumentasjon mangler',
  'avdl.diff.unverifiedBooked': 'Bokført saldo som ikke er verifisert',
  'avdl.diff.debtWithoutLoan': 'Gjeldskontoer uten registrert lån',
  'avdl.diff.notADifference': 'Dette er ikke en differanse. Det er gjeld ingen ekstern kilde har bekreftet, og den kan derfor ikke settes til «avstemt» ved at tallene tilfeldigvis stemmer med hverandre.',
  'avdl.diff.requestDocsCustomer': 'Be kunden om dokumentasjon',
  'avdl.diff.partC': 'C. Andre åpne forhold',
  'avdl.diff.accruedInterest': 'Påløpte renter som ikke er bokført',
  'avdl.diff.fees': 'Gebyrer som ikke er bokført',
  'avdl.diff.foreign': 'Lån i utenlandsk valuta',
  'avdl.diff.possibleMisclass': 'Mulig feil kortsiktig/langsiktig klassifisering',
  'avdl.diff.footerNote': 'Identifiserte forhold inngår ikke som løste eller forklarte poster før tiltaket er gjennomført eller dokumentert. Beløpene her er opplyst på lånene, ikke bokført.',
  'avdl.items.title': 'Avstemmingsposter',
  'avdl.items.noAccount': 'Området har ingen avstemmingskonto i denne perioden, og postene kan derfor ikke lagres.',
  'avdl.items.note': 'Postene forklarer differansen mot långiverne. Beløpet og begrunnelsen er det som teller i regnestykket — en post uten begrunnelse forklarer ingenting.',
  'avdl.items.description': 'Beskrivelse',
  'avdl.items.noLoan': 'Ikke knyttet til et lån',
  'avdl.items.amount': 'Beløp',
  'avdl.items.add': 'Legg til',
  'avdl.items.colLoan': 'Lån',
  'avdl.items.colDate': 'Dato',
  'avdl.items.colAction': 'Tiltak',
  'avdl.items.resolved': 'Løst',
  'avdl.items.open': 'Åpen',
  'avdl.items.reopen': 'Gjenåpne',
  'avdl.items.markResolved': 'Marker løst',
  'avdl.items.delete': 'Slett',
  'avdl.items.empty': 'Ingen avstemmingsposter registrert.',
  'avdl.carry.title': 'Fremfør saldo til periodens slutt',
  'avdl.drawer.close': 'Lukk',
  'avdl.carry.note': 'Långiverens saldo på dokumentdatoen, rullet fram med det som skjedde etterpå. Avdrag reduserer gjelden; nye trekk, renter og gebyrer øker den.',
  'avdl.carry.baseBalance': 'Saldo ifølge dokumentet',
  'avdl.carry.baseDate': 'Dokumentets saldodato',
  'avdl.carry.installments': 'Avdrag etter dokumentdato',
  'avdl.carry.drawdowns': 'Nye trekk',
  'avdl.carry.interestAndFees': 'Renter og gebyrer',
  'avdl.carry.other': 'Andre bevegelser',
  'avdl.carry.computed': 'Beregnet saldo ved periodens slutt',
  'avdl.carry.comparedToLedger': 'Sammenliknet med hovedboken',
  'avdl.carry.apply': 'Bruk fremført saldo i avstemmingen',
  'avdl.carry.cancel': 'Avbryt',
  'avdl.drawer.loanFallback': 'Lån',
  'avdl.drawer.noLoanNumber': 'Uten lånenummer',
  'avdl.drawer.accountPrefix': 'konto {account}',
  'avdl.drawer.loanHeading': 'Lånet',
  'avdl.drawer.loanNote': 'Lagres i foretakets låneregister og gjelder alle perioder.',
  'avdl.drawer.lender': 'Långiver',
  'avdl.drawer.loanName': 'Lånenavn',
  'avdl.drawer.loanNumber': 'Lånenummer',
  'avdl.drawer.ledgerAccount': 'Hovedbokskonto',
  'avdl.drawer.ledgerAccountHint': 'Kontoen lånet er bokført på',
  'avdl.drawer.chooseAccount': 'Velg konto',
  'avdl.drawer.currency': 'Valuta',
  'avdl.drawer.originalAmount': 'Opprinnelig lånebeløp',
  'avdl.drawer.interestRate': 'Rentesats',
  'avdl.drawer.repaymentType': 'Nedbetalingstype',
  'avdl.drawer.termsPerYear': 'Terminer per år',
  'avdl.drawer.monthly': 'Månedlig',
  'avdl.drawer.quarterly': 'Kvartalsvis',
  'avdl.drawer.semiannual': 'Halvårlig',
  'avdl.drawer.annual': 'Årlig',
  'avdl.drawer.installmentAmount': 'Terminbeløp',
  'avdl.drawer.remainingTerms': 'Gjenstående terminer',
  'avdl.drawer.startDate': 'Startdato',
  'avdl.drawer.endDate': 'Sluttdato',
  'avdl.drawer.interestOnlyUntil': 'Avdragsfrihet til',
  'avdl.drawer.security': 'Sikkerhet/pant',
  'avdl.drawer.next12': 'Avdrag neste 12 måneder etter planen',
  'avdl.drawer.planInsufficient': 'Planen holder ikke',
  'avdl.drawer.bookedOnAccount': 'Bokført saldo på kontoen',
  'avdl.drawer.needsAccount': 'Lånet må ligge på en hovedbokskonto.',
  'avdl.drawer.saveLoan': 'Lagre lånet',
  'avdl.drawer.removeLoan': 'Fjern lånet fra registeret',
  'avdl.drawer.periodDocs': 'Dokumentasjon for perioden',
  'avdl.drawer.periodDocsNote': 'Långiverens saldo for denne perioden. Lagres på avstemmingen, ikke på lånet.',
  'avdl.drawer.lenderBalance': 'Saldo ifølge långiver',
  'avdl.drawer.balanceDate': 'Saldodato',
  'avdl.drawer.periodEndIs': 'Periodeslutt er {date}',
  'avdl.drawer.lenderPerDoc': 'Långiver ifølge dokumentet',
  'avdl.drawer.linkedDoc': 'Koblet dokument',
  'avdl.drawer.notLinked': 'Ikke koblet',
  'avdl.drawer.accruedInterest': 'Påløpte, ikke bokførte renter',
  'avdl.drawer.fees': 'Gebyrer som ikke er bokført',
  'avdl.drawer.docIssue': 'Innvending mot dokumentet',
  'avdl.drawer.comment': 'Kommentar',
  'avdl.drawer.commentPlaceholder': 'Hva viser dokumentasjonen, og hva står igjen?',
  'avdl.drawer.documentDate': 'dokumentdatoen',
  'avdl.drawer.carriedNote': 'Saldoen er fremført fra {date}: {base} − avdrag {installments} + trekk {drawdowns} + renter og gebyrer {fees} + andre {other}.',
  'avdl.drawer.saveDocs': 'Lagre dokumentasjonen',
  'avdl.drawer.carryForward': 'Fremfør saldo til periodeslutt',
});
